/*
 * Copyright (c) 2024. . Yantodev - All Rights Reserved.
 * @Author  :  yantodev
 * mailto : ekocahyanto007@gmail.com
 * link : https://yantodev.my.id/
 */

import { REQUEST_SCOPE, REQUEST_SCOPE_FAILURE, REQUEST_SCOPE_SUCCESS } from "../../constant/UserAccessMenuConstant";

const initialState = {
    scope: {
        data: [],
        status: 'idle',
        isLoading: true,
    },
};


export const scopeReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case REQUEST_SCOPE:
            return {
                ...state,
                scope: {
                    data: [],
                    status: 'fetching',
                    isLoading: true,
                },
            };
        case REQUEST_SCOPE_SUCCESS:
            return {
                ...state,
                scope: {
                    data: payload,
                    status: 'ready',
                    isLoading: false,
                },
            };
        case REQUEST_SCOPE_FAILURE:
            return {
                ...state,
                scope: {
                    data: [],
                    status: 'fetching',
                },
            };
        default:
            return state;
    }
}
